@if (componentData.data$ | async; as component) {
  <div
    class="cta-block"
    [ngClass]="{ 'pb-0': component.removeBottomSpacing | safeCheck }"
  >
    <div class="container">
      <div class="row">
        <div class="cta-block-inner col col-sm-10 col-md-8 col-lg-6">
          <h2>{{ component.title }}</h2>
          <p>{{ component.text || component.subtitle }}</p>
          @if (component.typeCode === 'CtaComponent') {
            @if (component.link) {
              <a
                boelsAnchorButton
                boelsGenericLink
                tabindex="0"
                [variant]="'primary-brand'"
                [mode]="'inverted'"
                [componentData]="component"
              >
                {{ component.title }}
              </a>
            }
          }
          @if (component.typeCode === 'CTAContactComponent') {
            @if (component.emailAddress) {
              <a
                boelsAnchorButton
                href="mailto:{{ component.emailAddress }}"
                tabindex="0"
                [variant]="'primary-brand'"
                [mode]="'inverted'"
                [icon]="faEnvelope"
              >
                {{ component.emailAddress }}</a
              >
            }
            @if (component.phoneNumber && !component.emailAddress) {
              <a
                boelsAnchorButton
                href="tel:{{ component.phoneNumber | phoneFilter }}"
                tabindex="0"
                [variant]="'primary-brand'"
                [mode]="'inverted'"
                [icon]="faEnvelope"
              >
                <span>{{ component.phoneNumber }}</span>
                @if (component.phoneRate) {
                  <span class="phone-rate">{{ component.phoneRate }}</span>
                }
              </a>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
